import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RateService {
  destroy$ = new Subject<any>();

  baseRateCurrency : string = '';

  constructor(private httpProvider : HttpProviderService) { }

  fetchBaseRateCurrency(){
    const requestPayload : HttpRequestPayload = {
      method : 'GET',
      resource : '/install/CBXR'
    }
    this.httpProvider.invokeApi(requestPayload).pipe(takeUntil(this.destroy$)).subscribe((res:IHttpSuccessPayload<any>)=>{
      this.baseRateCurrency = res.body?.install?.baseCurrency;
    })
  }
}
